<template>
    <div class="rule-content">
      <div class="align-center padding-h5">
        <el-tag
          class="clickable"
          :type="linkType.type"
          size="mini"
          effect="dark"
          style="padding: 0 5px"
          @click="switchLinkType()"
        >
          {{ linkType.linkDesc }}
        </el-tag>
      </div>
      <div
        :class="rule.children.length ? 'rule-content-group' : ''"
        v-if="rule.children.length"
      >
        <div v-if="rule.children.length" class="rule-group-header">
          <i class="el-icon-s-operation"></i>
          <span>分</span>
          <span>组</span>
        </div>
        <RuleExpression
          style="margin: 5px 10px"
          v-for="(item, i) in rule.children"
          :key="i"
          :rule="item"
          @removeCondition="removeRuleCondition(item, i)"
        ></RuleExpression>
        <div style="padding: 0 0 3px 15px">
          <el-button
            type="danger"
            size="mini"
            icon="el-icon-plus"
            @click="addCondition"
          >
            条件
          </el-button>
          <el-button
            type="primary"
            size="mini"
            icon="el-icon-plus"
            @click="addGroup"
          >
            分组
          </el-button>
        </div>
      </div>
      <div v-else class="rule-condition">
        <el-row type="flex" style="width: 100%" class="margin-v3" align="middle">
          <el-select
            style="max-width: 120px; margin-right: 5px"
            size="mini"
            v-model="rule.code"
            @change="changeRule()"
          >
            <el-option
              v-for="item in codeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-select
            style="max-width: 120px; margin-right: 5px"
            size="mini"
            v-model="rule.compareType"
            @change="changeRule()"
          >
            <el-option
              v-for="item in compareTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <div style="flex: 1">
            <el-input-number
              style="width: 100%"
              v-if="rule.code == 'age'"
              v-model="rule.compareValue"
              controls-position="right"
              :min="0"
              :max="150"
              size="mini"
            >
            </el-input-number>
            <el-select
              v-else-if="rule.code == 'clinicType' || rule.code == 'gender'"
              :multiple="rule.multiple"
              style="width: 100%"
              size="mini"
              v-model="rule.compareValue"
            >
              <el-option
                v-for="item in valueMap[rule.code]"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-input
              style="width: 100%"
              v-else
              v-model="rule.compareValue"
              size="mini"
            ></el-input>
          </div>
          <el-button
            style="margin-left: 10px"
            type="info"
            circle
            size="mini"
            icon="el-icon-minus"
            @click="removeCondition"
          ></el-button>
        </el-row>
      </div>
    </div>
  </template>

  <script>
  import RuleExpression from "./RuleExpression";
  export default {
    name: "RuleExpression",
    components: { RuleExpression },
    props: {
      rule: {
        type: Object,
        default: () => {
          return {
            children: [],
          };
        },
      },
    },
    data() {
      return {
        codeOptions: [
          {
            value: "partName",
            label: "检查部位",
            compareTypes: ["in", "!in"],
          },
          {
            value: "projectName",
            label: "检查项目",
            compareTypes: ["in", "!in"],
          },
          {
            value: "deptName",
            label: "科室",
            compareTypes: ["=", "!=", "in", "!in"],
          },
          {
            value: "clinicType",
            label: "就诊类型",
            compareTypes: ["="],
          },
          {
            value: "checkType",
            label: "检查类型",
            compareTypes: ["in", "!in"],
          },
          {
            value: "gender",
            label: "性别",
            compareTypes: ["="],
          },
          {
            value: "age",
            label: "年龄",
            compareTypes: [">", "<", ">=", "<="],
          },
          {
            value: "remark",
            label: "申请单备注",
            compareTypes: ["in", "!in"],
          },
        ],
        compareOptions: [
          {
            value: "=",
            label: "等于",
          },
          {
            value: "!=",
            label: "不等于",
          },
          {
            value: ">",
            label: "大于",
          },
          {
            value: "<",
            label: "小于",
          },
          {
            value: ">=",
            label: "大于等于",
          },
          {
            value: "<=",
            label: "小于等于",
          },
          {
            value: "in",
            label: "包含",
          },
          {
            value: "!in",
            label: "不包含",
          },
        ],
        valueMap: {
          clinicType: [
            { value: "inpatient", label: "住院" },
            { value: "outpatient", label: "门诊" },
          ],
          gender: [
            { value: "M", label: "男" },
            { value: "W", label: "女" },
          ],
        },
      };
    },
    computed: {
      compareTypes(compareCode) {
        var codeOption = this.codeOptions.find((c) => c.value == this.rule.code);
        if (codeOption) {
          return this.compareOptions.filter(
            (c) => codeOption.compareTypes.indexOf(c.value) >= 0
          );
        }
        return [];
      },
      linkType() {
        if (this.rule.linkType) {
          if (this.rule.linkType == "&") {
            return {
              linkDesc: "并且",
              type: "danger",
            };
          } else {
            return {
              linkDesc: "或者",
              type: "warning",
            };
          }
        } else {
          return {
            linkDesc: "开始",
            type: "success",
          };
        }
      },
    },
    watch: {
      depts() {
        this.valueMap.deptId = this.depts;
      },
      parts() {
        this.valueMap.partId = this.parts;
      },
    },
    methods: {
      switchLinkType() {
        if (this.rule.linkType) {
          this.rule.linkType = this.rule.linkType == "&" ? "|" : "&";
        }
      },
      changeRule() {
        let compareType = this.compareTypes.find(
          (c) => c.value == this.rule.compareType
        );
        if (!compareType) {
          compareType = this.compareTypes[0];
          this.rule.compareType = compareType.value;
        }
        var codeOption = this.compareOptions.find(
          (c) => c.value == compareType.value
        );
        this.rule.multiple = false;
        this.rule.compareValue = "";
      },
      addCondition() {
        this.rule.children.push({
          code: "partName",
          compareType: "in",
          multiple: false,
          value: "",
          levelNo: this.rule.levelNo + 1,
          compareValue: "",
          linkType: "&",
          children: [],
        });
      },
      addGroup() {
        this.rule.children.push({
          code: "group",
          compareType: "-",
          multiple: false,
          value: "",
          levelNo: this.rule.levelNo + 1,
          compareValue: "-",
          linkType: "&",
          children: [
            {
              code: "partName",
              compareType: "in",
              multiple: false,
              value: "",
              compareValue: "",
              levelNo: this.rule.levelNo + 2,
              linkType: "",
              children: [],
            },
          ],
        });
      },
      removeCondition(rule) {
        this.$emit("removeCondition");
      },
      removeRuleCondition(rule, index) {
        this.rule.children.splice(index, 1);
        if (!index && this.rule.children.length) this.rule.children[0].linkType = "";
        if (!this.rule.children.length) {
          this.$emit("removeCondition");
        }
      },
    },
  };
  </script>

  <style scoped>
  .rule-content {
    background-color: #fafafa;
    display: flex;
    align-items: center;
    margin: 5px 5px 0 0;
  }
  .rule-content-group {
    border: 1px #409eff solid;
    position: relative;
    flex: 1;
    padding-left: 10px;
  }
  .rule-condition {
    border-bottom: 1px #d8d8d8 solid;
    /* padding: 0 10px; */
    /* margin: 3px 5px; */
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #409eff;
  }
  .rule-group-header {
    background-color: #409eff;
    color: white;
    flex-direction: row;
    width: 20px;
    text-align: center;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    /* padding: 0 6px; */
  }
  .rule-detail {
    /* padding: 5px; */
    /* margin: 0 5px; */
    outline: none;
    display: inline-block;
    background-color: #409eff;
    color: white;
  }
  </style>
